'use client';

import type { FormField } from '@/components/Form/helper/formHelper';
import { type StoreApi, create } from 'zustand';

export interface FlashState {
  formData: FormField[];
  setFormData: (formData: FormField[]) => void;
}

export function createFlashStore(initState: Partial<FlashState> = {}): StoreApi<FlashState> {
  return create<FlashState>()((set) => ({
    formData: [],
    setFormData: (formData) => set({ formData }),
    ...initState,
  }));
}

export type FlashStoreApi = ReturnType<typeof createFlashStore>;
